import { adfetch } from "./fetch";
import { downloadFile } from "./utils";

export function downloadFileById(fileId: string, fileName: string) {
  if (!fileId || !fileName) {
    throw new Error("wrong args");
  }

  return downloadFile(`/files/${fileId}`, fileName);
}

export function fetchFile(fileUrl: string) {
  if (!fileUrl) {
    throw new Error("wrong args");
  }

  return adfetch(fileUrl, {
    method: "get"
  })
    .then((res) => {
      return true;
    })
    .catch((error) => {
      return false;
    });
}
